import { render, staticRenderFns } from "./CompanySelect.vue?vue&type=template&id=095f9dea"
import script from "./CompanySelect.vue?vue&type=script&lang=ts"
export * from "./CompanySelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports